export default (state, action) => {

	let newTotal = 0;
	let updateShoppingCart = [];
	const { shoppingCart } = state;

	switch (action.type) {
		case 'ADD_ITEM':
			let passed = false;


			updateShoppingCart = shoppingCart.map((product) => {
				if (product.id === action.item.id && action.subCategory === null) {
					product.quantity = Number(action.quantity);
					passed = true;
				} else if (product.id === action.item.id && action.subCategory === product.subCategory) {
					product.quantity = Number(action.quantity);
					passed = true;
				}
				return product;
			});

			let price = action.item.price
			console.log("jajajaja VIENDO", action.item)
			if(action.item.price2 !== undefined && action.item.price2 !== ''){
				console.log("jajajaja")
				price = action.item.price2
			}

			if (!passed) {
				updateShoppingCart = updateShoppingCart.concat({
					id: action.item.id,
					name: action.item.name,
					price: price,
					quantity: Number(action.quantity),
					subCategory: action.subCategory,
					images: action.item.images,
					category: action.item.category
				});
			}

			updateShoppingCart.map((product) => (newTotal += product.price * product.quantity));
			return {
				...state,
				shoppingCart: updateShoppingCart,
				total: newTotal
			};
		
		case 'DELETE_ITEM':
			updateShoppingCart = shoppingCart.filter(
				(product) => product.id !== action.item.id || product.category !== action.item.category
			);
			updateShoppingCart.map(
				(product) => (
					(newTotal += product.price * product.quantity)
					
				)
			);

			return {
				...state,
				shoppingCart: updateShoppingCart,
				total: newTotal,
			};

		case 'ADD_SHOP_UID':
			return { 
				...state,
				shopUid: action.item.shopUid,
				shopColor: action.item.shopColor,
				userName: action.item.nameStore,
				name: action.item.name,
				urlPhoto: action.item.url,
				urlPortada: action.item.urlPortada,
				whatsapp: action.item.whatsapp,
				instagram: action.item.instagram,
				facebook: action.item.facebook,
				description: action.item.description,
				shopEmail: action.item.shopEmail,
				shopName: action.item.shopName,
				toggleWhatsAppMethod: action.item.toggleWhatsAppMethod,
				dispatchTime: action.item.dispatchTime,
				shopDirection: action.item.shopDirection,
				toggleWithdrawal: action.item.toggleWithdrawal,
				toggleDelivery: action.item.toggleDelivery,
				shoppingCart: [],
				delivery: action.item.delivery,
				deliveryInformation: action.item.deliveryInformation,
				footerItem: action.item.footerItem,
				total: 0
			};

		case 'ADD_CATEGORY':
			let products;
			for (const data of state.data) {
				if (data.category.name === action.item) {
					products = data.products;
				}
			}

			return {
				...state,
				category: action.item,
				products: products
			};

		case 'ADD_CATEGORIES_products':
			return {
				...state,
				data: action.item
			};

		case 'ADD_FOOTER_ITEM':

			return {
				...state,
				footerItem: action.item
			}
			

			
			

		default:
			return state;
	}
};
